import { render, staticRenderFns } from "./Segundo.vue?vue&type=template&id=c2005f56&scoped=true&"
import script from "./Segundo.vue?vue&type=script&lang=js&"
export * from "./Segundo.vue?vue&type=script&lang=js&"
import style0 from "./Segundo.vue?vue&type=style&index=0&id=c2005f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2005f56",
  null
  
)

export default component.exports